export const rules = [
  { id: 'rule_1', name: 'Pause unprofitable', condition: 'roas < 1.0 for 7d', action: 'pause', status: 'active' },
  { id: 'rule_2', name: 'Scale winners +20%', condition: 'roas > 4.0 for 7d', action: 'increase_budget', status: 'active' },
];
